import { sva } from "@filadd/phi-plus-styled-system/css";
export const topBarRecipe = sva({
    slots: ["container", "left", "trigger", "backButtonArrow"],
    base: {
        container: {
            width: "full",
            my: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
        left: {
            display: "flex",
            flexDir: "row",
            gap: 1,
            "& button": {
                p: 2,
            },
        },
        trigger: {
            display: "none!",
            mdDown: {
                display: "inline-flex!",
            },
        },
        backButtonArrow: {
            width: { md: "token(sizes.6)!" },
            height: { md: "token(sizes.6)!" },
        },
    },
});
//# sourceMappingURL=topBarRecipe.js.map